import axios from "axios";
import fireDb from "../../../api/firebase/realtime/utils";
import role from "../../../config/App-role";
import Act from "../../../store/actions";
import apiUrls from "../../../api/project/ApiUrls";

/* =========== group tool =========== */ //
//
export const getGroupsInfo = (groupsId = [], onSuccess, onError) => {
  // 搜尋 firebase 找到 groups 所有資料
  fireDb.getGroupsByIds(groupsId, onSuccess, onError);
};

//
export const getOneGroupFromGroups = (oneGroupId, userId, dispatch) => {
  // 從 groups 取出其中一個 group, fetch realtime 取得 group 基本資料
  const getGroupsInfoSuccess = (userGroupsFind) => {
    // console.log("userGroupsFind", userGroupsFind);
    const curGroupRole = (Object.values(userGroupsFind)[0] || {})?.members?.[
      userId
    ]?.role;
    dispatch({
      type: Act.USER_SET_CUR_GROUP,
      payload: {
        ...(Object.values(userGroupsFind)[0] || {}),
        role: curGroupRole,
      },
    });
  };
  const getGroupsInfoError = (err) => {
    dispatch({
      type: Act.COMMON_SET_ERROR_MESSAGE,
      payload: {
        open: true,
        content: err.message,
      },
    });
  };
  getGroupsInfo([oneGroupId], getGroupsInfoSuccess, getGroupsInfoError);
};

//
export const getUsersInfo = (usersId = [], groupId, onSuccess, onError) => {
  const handleSuccess = async (usersFind = []) => {
    // console.log("[getUsersInfo] usersFind", usersFind);
    const group = await fireDb.getGroupRt({ uid: groupId });
    let usersFormat = [];
    usersFormat = usersFind.reduce((acc, cur) => {
      // 過濾資料, 並取出 該成員的 role 資訊
      if (
        cur?.groups &&
        groupId in cur.groups &&
        cur.groups[groupId]?.isMember
      ) {
        acc.push({
          uid: cur?.uid,
          displayName: cur.displayName,
          groupId,
          role: cur.groups[groupId].role, // todo: 間接取得 user.role 的資料
        });
      }
      return acc;
    }, []);
    if (group) {
      const userFormatPlusRole = usersFormat.map((item) => ({
        ...item,
        role: group?.members?.[item?.uid]?.role,
      }));
      if (onSuccess) onSuccess(userFormatPlusRole);
    } else if (onSuccess) onSuccess(usersFormat);
  };
  // 搜尋 firebase 找到 user 所有資料
  fireDb.getUsersByIds(usersId, handleSuccess, onError);
};

//
export const deleteUserGroup = ({ groupId, userId, onSuccess, onFailure }) => {
  // update firebase, soft delete
  fireDb.deleteUserGroup({
    userId,
    groupId,
    data: {},
    onSuccess: () => {
      fireDb.deleteGroup({
        groupId,
        onSuccess: () => {
          if (onSuccess) onSuccess();
        },
        onError: (err) => {
          if (onFailure) onFailure(err);
        },
      });
    },
    onError: (err) => {
      if (onFailure) onFailure(err);
    },
  });
};

//
export const deleteGroupUser = ({ userId, groupId, onSuccess, onFailure }) => {
  // update firebase, soft delete
  // 變更 groups.[uid].members.[userUid] 的資訊
  fireDb.removeGroupMember({
    userId,
    groupId,
    data: {
      isMember: false,
      role: role.reader,
    },
    onSuccess: () => {
      axios
        .post(apiUrls.postDeleteUserGroup(), {
          userId,
          groupId,
          data: {}, // 帶空物件,即會刪除該筆資料
        })
        .then((res) => {
          const { status, data } = res;
          const { message, error } = res?.data;
          if (!status === 200 || message !== true) {
            throw Error("fail to update");
          }
          if (onSuccess) onSuccess();
        })
        .catch((err) => {
          if (onFailure) onFailure(err);
        });

      // realtime database 有設定安全規則,登入的使用者才可以修改他自己的資料,
      // 下面的方式會失敗
      // 變更 users.[uid].groups 的資訊
      // fireDb.updateUserGroups({
      //   userId,
      //   groupId,
      //   data: { isMember: false },
      //   onSuccess: () => {
      //     if (onSuccess) onSuccess();
      //   },
      //   onError: (err) => {
      //     if (onFailure) onFailure(err);
      //   },
      // });
    },
    onError: (err) => {
      if (onFailure) onFailure(err);
    },
  });
};

/**
 * 寄出邀請信
 * @param mailTemplate {{sendMail: {subject: string, from: {address: string, name: string}, to: *, text: string}}}
 * @returns {Promise<{success: boolean, error: string; providerId: null|undefined|string[]}>}
 */
export const sentGroupInvitation = async (mailTemplate) => {
  try {
    if (!(mailTemplate && mailTemplate.sendMail)) {
      return {
        success: false,
        error: "sendMail is required",
      };
    }
    const { from, to, subject, text, html } = mailTemplate.sendMail || {};
    if (!(from?.name && from?.address && to && subject)) {
      return {
        success: false,
        error: "mail template is not correct",
      };
    }
    if (!(text || html)) {
      return {
        success: false,
        error: "mail template is not correct",
      };
    }

    const res = await axios.post(apiUrls.postMail(), mailTemplate);
    if (res.status === 200 && !res.data?.error) {
      return {
        success: true,
        error: false,
      };
    }
    return {
      success: false,
      error: res.data?.error,
    };
  } catch (err) {
    return {
      success: false,
      error: err,
    };
  }
};

/**
 *
 * @param info {{email:string; groupId: string;}}
 * @returns {Promise<{success: boolean, error: string; userInfo: {email:string; displayName:string; userInGroup: boolean;}}>}
 */
export const checkUserInGroup = async (info) => {
  try {
    const { email, groupId } = info;
    if (!email) {
      return {
        success: false,
        error: "email is required for checkUserInGroup()",
      };
    }
    const res = await axios.post(apiUrls.postCheckUserInGroup(), {
      email,
      groupId,
    });
    if (res.status === 200) {
      const { userInGroup, user, error } = res.data;
      return {
        success: true,
        error: false,
        userInGroup,
        userInfo: user,
      };
    }
    return {
      success: false,
      error: "user is not in group",
      userInGroup: false,
      userInfo: null,
    };
  } catch (e) {
    console.log("err", e);
    return {
      success: false,
      error: e.message,
    };
  }
};
